import {createActions} from 'client/framework';

const normalActions = ['SET_IS_OPEN', 'RESET_STORE'];

export const tooltipActions = createActions(null, normalActions);
